import { LocalLoadable } from '@g2-shared/components';
import { lazy } from 'react';

export const CreatePartyPage = LocalLoadable(lazy(() => import('../pages/create-party')));

export const ProcessPartyCasePage = LocalLoadable(
  lazy(() => import('../pages/process-party-case'))
);
